export const educationData = [
    {
        id: 1,
        institution: 'École polytechnique fédérale de Lausanne - EPFL',
        course: 'Master of Robotics with a Minor in Data Sciences',
        startYear: '2023 - ',
        endYear: '2026'
    },
    {
        id: 2,
        institution: 'École polytechnique fédérale de Lausanne - EPFL',
        course: 'Microengineering Bachelor',
        startYear: '2019 - ',
        endYear: '2023'
    },
    {
        id: 3,
        institution: 'Technical University of Denmark - DTU',
        course: 'Exchange Year (Microengineering Bachelor)',
        startYear: '2022 - ',
        endYear: '2023'
    },
    {
        id: 4,
        institution: 'Exchange in  Victoria High School, Canada (2016)',
        course: 'French Bacalauréat - Scientific Section',
        startYear: '',
        endYear: '2019'
    },
]